import { Venue } from '../types/venue'

export const venues: Venue[] = [
  {
    id: 'lamunin',
    name: 'Lamunin Pickleball',
    location: 'Tutong',
    address: 'No.44, Kampong Kiudang, Tutong, Brunei',
    latitude: 4.73545,
    longitude: 114.73476,
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/9kkuUyBCwXcXfWGTqXGwqZ/CourtImageRotate1.webp',
    description:
      'Premium indoor facility with 6 courts featuring both Padel and Pickleball courts',
    totalCourts: 6,
    availableCourts: 5,
    rating: 4.8,
    reviews: 124,
    amenities: [
      'Indoor Courts',
      'LED Lighting',
      'Water Station',
      'Seating Area',
      'Equipment Rental',
    ],
    operatingHours: '8:00 AM - 2:00 AM Daily',
    priceRange: { min: 15, max: 20 },
    priceRangeUC: { min: 15, max: 20 },
  },
  {
    id: 'gadong',
    name: 'Gadong Sports Complex',
    location: 'Gadong',
    address: 'Jalan Gadong, Bandar Seri Begawan, Brunei',
    latitude: 4.9082,
    longitude: 114.9189,
    image:
      'https://images.unsplash.com/photo-1554068865-24cecd4e34b8?w=800&h=600&fit=crop',
    description:
      'Modern sports complex in the heart of Gadong with 4 premium courts',
    totalCourts: 4,
    availableCourts: 3,
    rating: 4.6,
    reviews: 89,
    amenities: [
      'Indoor Courts',
      'Air Conditioning',
      'Pro Shop',
      'Café',
      'Parking',
    ],
    operatingHours: '7:00 AM - 11:00 PM Daily',
    priceRange: { min: 18, max: 25 },
    priceRangeUC: { min: 18, max: 25 },
  },
  {
    id: 'berakas',
    name: 'Berakas Sports Complex',
    location: 'Berakas',
    address: 'Jalan Berakas, Bandar Seri Begawan, Brunei',
    latitude: 4.9603,
    longitude: 114.9635,
    image:
      'https://images.unsplash.com/photo-1622163642998-1ea32b0bbc67?w=800&h=600&fit=crop',
    description:
      'Largest facility in Brunei with 8 courts and tournament-grade equipment',
    totalCourts: 8,
    availableCourts: 6,
    rating: 4.9,
    reviews: 156,
    amenities: [
      'Indoor & Outdoor',
      'Tournament Grade',
      'Locker Rooms',
      'Coaching Available',
      'Restaurant',
    ],
    operatingHours: '6:00 AM - 12:00 AM Daily',
    priceRange: { min: 20, max: 30 },
    priceRangeUC: { min: 20, max: 30 },
  },
  {
    id: 'seria',
    name: 'Seria Recreation Club',
    location: 'Seria',
    address: 'Jalan Tengah, Seria, Belait, Brunei',
    latitude: 4.6065,
    longitude: 114.3244,
    image:
      'https://images.unsplash.com/photo-1617883861744-5a4a37f0e1f0?w=800&h=600&fit=crop',
    description: 'Community-focused facility with 3 well-maintained courts',
    totalCourts: 3,
    availableCourts: 2,
    rating: 4.5,
    reviews: 67,
    amenities: [
      'Outdoor Courts',
      'Natural Lighting',
      'Community Events',
      'Beginner Friendly',
    ],
    operatingHours: '8:00 AM - 10:00 PM Daily',
    priceRange: { min: 12, max: 18 },
    priceRangeUC: { min: 12, max: 18 },
  },
]

export function getVenueById(id: string): Venue | undefined {
  return venues.find((v) => v.id === id)
}
